module.exports = __webpack_public_path__ + "img/grid-listing-inactive.9ea9d845.svg";